import React, { useState } from 'react';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import { FaArrowLeft, FaPencilAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { useFirestore } from '../../../hooks/useFirestore';
import { useAlert } from '../../../contexts/alerta';
import InputFile from '../../../components/inputFile';
import { FaXmark } from 'react-icons/fa6';
import { mensagemNovoRelato } from '../../../hooks/useEmail';

export default function New(params) {
  const [showForm, setShowForm] = useState(false)
  const [showUserForm, setShowUserForm] = useState(false)
  const [showAnonForm, setShowAnonForm] = useState(false)
  const [form, setForm] = useState({
    nome: '',
    email: '',
    telefone: '',
    motivo: '',
    relato: '',
    protocolo: '',
    anexos: []
  })
  const [anexos, setAnexos] = useState([])

  const { novoRelato } = useFirestore()
  const nav = useNavigate();
  const { addAlert } = useAlert()

  const handleShowForm = () => {
    setShowForm(true)
    setShowAnonForm(true)
    setShowUserForm(false)
  }

  const handleUserForm = () => {
    setShowUserForm(true)
    setShowAnonForm(false)
    setShowForm(true)
  }

  const handleChangeInput = (value, type) => {
    setForm({ ...form, [type]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    form.anexos = anexos

    novoRelato(form)
      .then(res => {
        mensagemNovoRelato({ idRelato: res.uuid })
        nav('/sucess', { state: { relato: res } })
      })
      .catch((e) => {
        addAlert('Um problema inesperado ocorreu!', "error")
      })
  }

  const addAnexo = (anexo) => {
    setAnexos([...anexos, anexo])
  }

  const removeAnexo = (id) => {
    setAnexos(
      anexos.filter(a =>
        a.arquivo !== id
      )
    );
  }

  const mascaraTelefone = value => {
    return value
      .replace(/\D/g, '')
      .replace(/(\d{2})(\d)/, '+$1 $2')
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .replace(/(-\d{4})\d+?$/, '$1')
  }

  return (
    <div >
      <Navbar />
      <main className='flex mt-40 flex-col '>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto'>
          <div className='flex justify-between mb-8'>
            <h1 className='flex text-primary items-center text-3xl gap-4 font-semibold'><FaPencilAlt />REALIZAR RELATO</h1>
            <a className='flex items-center text-base text-secondary gap-2 font-semibold' href="/">
              <FaArrowLeft />
              <span className='hidden lg:block'>VOLTAR</span>
            </a>
          </div>
          <hr className='border-background mb-8' />
          <div className='text-secondary flex flex-col gap-4 text-lg'>
            <p>Por favor, descreva a situação. Ao fazer seu relato observe os pontos abaixo para que nossa comunicação seja a mais completa e detalhada possível, dessa forma contribuirá para que possamos ter êxito na apuração.</p>
            <p>Assim, não se esqueça de incluir na descrição do seu relato, se possível:</p>
            <ul className='list-disc ml-8'>
              <li><b>O quê:</b> descreva a situação ou fato, que gostaria de relatar;</li>
              <li><b>Quem:</b> nome ou "apelido" de envolvidos (pessoas, empresas, testemunhas);</li>
              <li><b>Quando:</b> data exata ou aproximada em que ocorreu, ocorre ou irá ocorrer o fato/situação;</li>
              <li><b>Onde:</b> local, setor, área, departamento e unidade da situação relatada;</li>
              <li><b>Quanto:</b> se for possível e tiver informações de quantidade, valores, volumes, etc;</li>
              <li><b>Evidências ou provas:</b> se existem e onde podem ser encontradas.</li>
            </ul>
            <p>Para acompanhar o andamento de seu relato você poderá utilizar o protocolo fornecido após o envio do relato.</p>
            <p>Agradecemos sua iniciativa e confiança.</p>
          </div>
        </section>
        <section className='lg:w-4/6 md:w-5/6 w-11/12 m-auto mt-8 mb-8' >
          <div className='flex flex-col lg:flex-row gap-8'>
            <button
              style={{ backgroundColor: showUserForm && '#0C4187', color: showUserForm && '#fff' }}
              onClick={() => handleUserForm()}
              className='p-8 border border-background shadow-md rounded-md text-xl font-semibold'
            >
              Sim, desejo me identificar
            </button>
            <button
              style={{ backgroundColor: showAnonForm && '#0C4187', color: showAnonForm && '#fff' }}
              onClick={() => handleShowForm()}
              className='p-8 border border-background shadow-md rounded-md text-xl font-semibold'
            >
              Não, desejo ficar anônimo
            </button>
          </div>
          <div>
            <form onSubmit={handleSubmit}>
              {showUserForm &&
                <div className='mt-8'>
                  <h1 className='text-primary text-xl font-semibold'>SEUS DADOS</h1>
                  <h3 className='text-secondary text-lg font-semibold'>PREENCHA COM SUAS INFORMAÇÕES PESSOAIS</h3>
                  <div className='bg-background p-8 flex flex-col gap-8'>
                    <label htmlFor="name" className='flex flex-col text-xl text-secondary'>Nome:
                      <input className='text-base font-semibold rounded-md outline-primary p-2' type="text" id='name' placeholder='Nome' value={form.nome} onChange={e => handleChangeInput(e.target.value, 'nome')} />
                    </label>
                    <div className='flex flex-col lg:flex-row w-full gap-8'>
                      <label htmlFor="email" className='flex flex-col text-xl text-secondary w-full'>E-mail:
                        <input className='text-base font-semibold rounded-md outline-primary p-2' type="email" id='email' placeholder='E-mail' value={form.email} onChange={e => handleChangeInput(e.target.value, 'email')} />
                      </label>
                      <label htmlFor="telefone" className='flex flex-col text-xl text-secondary w-full'>Telefone:
                        <input className='text-base font-semibold rounded-md outline-primary p-2' type="text" id='telefone' placeholder='telefone' value={form.telefone} onChange={e => handleChangeInput(mascaraTelefone(e.target.value), 'telefone')} />
                      </label>
                    </div>
                  </div>
                </div>
              }
              {showForm &&
                <div className='mt-8'>
                  <h1 className='text-primary text-xl font-semibold'>MOTIVOS DO CONTATO</h1>
                  <h3 className='text-secondary text-lg font-semibold'>MOTIVO DO RELATO</h3>
                  <div className='bg-background p-8 flex flex-col gap-8'>
                    <select
                      name="motivo"
                      id="motivo"
                      required
                      value={form.motivo}
                      onChange={e => handleChangeInput(e.target.value, 'motivo')}
                      className='font-semibold bg-white rounded-md border-0 bg-transparent p-4 lg:w-1/2 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm'
                    >
                      <option value="">SELECIONE</option>
                      <option value="elogio">Elogio</option>
                      <option value="sugestoes">Sugestões</option>
                      <option value="duvidas">Dúvidas</option>
                      <option value="solicitacoes">Solicitações</option>
                      <option value="denuncia">Denúncia</option>
                      <option value="reclamacao">Reclamação</option>
                    </select>
                    <label className='flex flex-col text-xl text-secondary font-semibold' htmlFor="relato">
                      Detalhe seu relato:
                      <textarea
                        required
                        name="relato"
                        id="relato"
                        rows="5"
                        value={form.relato} onChange={e => handleChangeInput(e.target.value, 'relato')}
                        className='rounded-md p-1 focus:ring-1 focus:ring-primary focus:outline-primary'
                      ></textarea>
                    </label>
                    <div className="row">
                      <label className='flex flex-col lg:flex-row text-secondary font-semibold justify-between lg:items-center' htmlFor="protocolo">
                        Se este relato está relacionado com outro, insira aqui o protocolo anterior:
                        <input className='lg:w-1/2 p-4 rounded-md outline-primary' type="text" id='protocolo' value={form.protocolo} onChange={e => handleChangeInput(e.target.value, 'protocolo')} />
                      </label>
                    </div>
                    <div className='text-secondary'>
                      <p><b>Se você tiver imagem na tela, foto, texto, áudio ou vídeo, que possa contribuir com o seu relato, por favor nos envie:</b></p>
                      <p>* Extensões possíveis: jpg,jpeg,png</p>
                      <p>** Tamanho máximo 5MB</p>
                    </div>
                    <div className='flex flex-col gap-2'>
                      <span className='font-semibold text-primary'>Anexos:</span>
                      {
                        anexos.map((anexo, i) => (
                          <div className='flex items-center gap-3' key={i}>
                            <span className='font-semibold text-primary'>
                              {anexo.nomeArquivo}
                            </span>
                            <span className='hover:cursor-pointer text-warning' onClick={() => removeAnexo(anexo.arquivo)}><FaXmark /></span>
                          </div>
                        ))
                      }
                      <InputFile name={anexos.length + 1} change={addAnexo} label={`Enviar arquivo`} />
                    </div>
                  </div>
                  <div className='flex justify-end'>
                    <input type="submit" value="Enviar" className='px-8 py-4 uppercase text-lg bg-secondary rounded-md mt-8 text-background font-semibold hover:bg-primary hover:text-white hover:cursor-pointer' />
                  </div>
                </div>
              }
            </form>
          </div>
        </section >
      </main >
      <Footer />
    </div >
  )
};
